import { translateString } from '@src/util/intl/translateString';

export const DEVIATIONS_FROM_TASK_COMPLIANCE_DATA_SOURCE = [
  {
    key: 'scheduleTaskSummaryName',
    name: translateString('dashboards.deviations.column.templateName'),
    description: translateString('dashboards.deviations.column.templateName.description'),
    isActive: true,
    order: 1,
  },
  {
    key: 'scheduleName',
    name: translateString('dashboards.deviations.column.taskName'),
    description: translateString('dashboards.deviations.column.taskName.description'),
    isActive: true,
    order: 2,
  },
  {
    key: 'status',
    name: translateString('dashboards.deviations.column.status'),
    description: translateString('dashboards.deviations.column.status.description'),
    isActive: true,
    order: 3,
  },
  {
    key: 'users',
    name: translateString('dashboards.deviations.column.users'),
    description: translateString('dashboards.deviations.column.users.description'),
    isActive: true,
    order: 4,
  },
  {
    key: 'createdAt',
    name: translateString('dashboards.deviations.column.creation'),
    description: translateString('dashboards.deviations.column.creation.description'),
    isActive: true,
    order: 5,
  },
  {
    key: 'assignedAt',
    name: translateString('dashboards.deviations.column.assignedAt'),
    description: translateString('dashboards.deviations.column.assignedAt.description'),
    isActive: true,
    order: 6,
  },
  {
    key: 'delayToAssignUsers',
    name: translateString('dashboards.deviations.column.delayToAssignUsers'),
    description: translateString('dashboards.deviations.column.delayToAssignUsers.description'),
    isActive: true,
    order: 7,
  },
  {
    key: 'startDate',
    name: translateString('dashboards.deviations.column.startDate'),
    description: translateString('dashboards.deviations.column.startDate.description'),
    isActive: true,
    order: 8,
  },
  {
    key: 'start',
    name: translateString('dashboards.deviations.column.start'),
    description: translateString('dashboards.deviations.column.start.description'),
    isActive: true,
    order: 9,
  },
  {
    key: 'startDelay',
    name: translateString('dashboards.deviations.column.startDelay'),
    description: translateString('dashboards.deviations.column.startDelay.description'),
    isActive: true,
    order: 10,
  },
  {
    key: 'endDate',
    name: translateString('dashboards.deviations.column.endDate'),
    description: translateString('dashboards.deviations.column.endDate.description'),
    isActive: true,
    order: 11,
  },
  {
    key: 'end',
    name: translateString('dashboards.deviations.column.end'),
    description: translateString('dashboards.deviations.column.end.description'),
    isActive: true,
    order: 12,
  },
  {
    key: 'assignedDuration',
    name: translateString('dashboards.deviations.column.assignedDuration'),
    description: translateString('dashboards.deviations.column.assignedDuration.description'),
    isActive: true,
    order: 13,
  },
  {
    key: 'assignedRealDuration',
    name: translateString('dashboards.deviations.column.assignedRealDuration'),
    description: translateString('dashboards.deviations.column.assignedRealDuration.description'),
    isActive: true,
    order: 14,
  },
  {
    key: 'differenceDuration',
    name: translateString('dashboards.deviations.column.differenceDuration'),
    description: translateString('dashboards.deviations.column.differenceDuration.description'),
    isActive: true,
    order: 15,
  },
  {
    key: 'forms',
    name: translateString('dashboards.deviations.column.forms'),
    description: translateString('dashboards.deviations.column.forms.description'),
    isActive: true,
    order: 16,
  },
  {
    key: 'events',
    name: translateString('dashboards.deviations.column.events'),
    description: translateString('dashboards.deviations.column.events.description'),
    isActive: true,
    order: 17,
  },
  {
    key: 'delays',
    name: translateString('dashboards.deviations.column.delays'),
    description: translateString('dashboards.deviations.column.delays.description'),
    isActive: true,
    order: 18,
  },
  {
    key: 'totalDelayDuration',
    name: translateString('dashboards.deviations.column.totalDelayDuration'),
    description: translateString('dashboards.deviations.column.totalDelayDuration.description'),
    isActive: true,
    order: 19,
  },
];
